import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class EfacturaPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.efacturaRead,
        );
        this.create = permissionChecker.match(
            Permissions.values.efacturaCreate,
        );
        this.authenticate = permissionChecker.match(
            Permissions.values.efacturaAuthenticate,
        );
    }
}
